import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Division } from '../../../models/division';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, map } from 'rxjs';
import { findDivisionAct, saveDivisionAct, updateDivisionAct } from '../../../store/division/division.actions';

@Component({
  selector: 'app-divisions-detail',
  standalone: false,
  templateUrl: './divisions-detail.component.html',
  styleUrl: './divisions-detail.component.css'
})
export class DivisionsDetailComponent {

  divisionForm!: NgForm;
  loading = true;
  title!: string;
  division: Division = new Division();
  violations: any;

  constructor(
    private route: ActivatedRoute,
    private divisionStore: Store<{divisionRdc: any}>
  ) {
    this.divisionStore.pipe(
      select('divisionRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        division: state.division,
        violations: state.violations,
        loading: state.loading
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ division, violations, loading }) => {
      this.division = JSON.parse(JSON.stringify(division));
      this.violations = violations;
      this.loading = loading;
      this.title = 'Detalles de Division';


      if(this.divisionForm){
      
        Object.keys(this.divisionForm.controls).forEach(controlName => {
          const control = this.divisionForm.controls[controlName];
          if (this.violations[controlName]) {
            control.setErrors({ backend: true }); // Marca error
          }
        });
      }

    });
  }

  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {
      const id: number = + (params.get('id') || '0');
      if(id > 0){
        this.divisionStore.dispatch(findDivisionAct({ id }));
      }else{
        this.division = new Division();
        this.division.active = true;
        this.loading = false;
        this.title = 'Agregar Division';
      }
    });

  }

  onSubmitDivision(divisionForm: NgForm): void {
    //this.loading = true;
    this.divisionForm = divisionForm;
    const divisionCopy = JSON.parse(JSON.stringify(this.division));
    
    if (divisionCopy.id > 0) {
      this.divisionStore.dispatch(updateDivisionAct({ divisionUpdated: divisionCopy }))
    } else {
      this.divisionStore.dispatch(saveDivisionAct({ divisionNew: divisionCopy }))
    }
  }
}
